export const CONTENT_CONTROL = 0;
export const TABLE = 1;